import * as React from 'react';
import { Query } from 'react-apollo';

import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';

import EnterpriseBffCourseContext from 'bundles/unified-description-page-common/contexts/enterprise/EnterpriseBffCourseContext';
import EnterpriseCoursePageQuery from 'bundles/unified-description-page-common/queries/bff/EnterpriseCoursePageQuery.graphql';
import type {
  EnterpriseCoursePageQuery as EnterpriseCoursePageQueryType,
  EnterpriseCoursePageQueryVariables,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import {
  RECOMMENDATIONS_LIMIT,
  getFormattedRecommendations,
} from 'bundles/unified-description-page-common/utils/getFormattedRecommendations';
import type { PartialCollectionType } from 'bundles/unified-description-page-common/utils/getFormattedRecommendations';

type PropsToComponent = {
  slug: string;
  programSlug: string;
  specializationSlug?: string;
  children: React.ReactNode;
};

const EnterpriseEnterpriseBffCourseDataProvider = ({
  slug,
  programSlug,
  specializationSlug,
  children,
}: PropsToComponent) => {
  return (
    <Query<EnterpriseCoursePageQueryType, EnterpriseCoursePageQueryVariables>
      query={EnterpriseCoursePageQuery}
      variables={{ slug, programSlug, specializationSlug, limit: RECOMMENDATIONS_LIMIT }}
      context={{ clientName: 'gatewayGql' }}
      errorPolicy="all"
    >
      {({ data, loading, error }) => {
        const enterpriseCoursePageData = data?.DescriptionPage?.queryEnterpriseCoursePage;
        const relatedRecs = enterpriseCoursePageData?.relatedRecommendations as PartialCollectionType;
        const coursePage = enterpriseCoursePageData
          ? {
              ...enterpriseCoursePageData,
              relatedRecommendations: getFormattedRecommendations(relatedRecs),
            }
          : enterpriseCoursePageData;
        return (
          <EnterpriseBffCourseContext.Provider value={{ coursePage, isCourseDataLoading: loading, error }}>
            {children}
          </EnterpriseBffCourseContext.Provider>
        );
      }}
    </Query>
  );
};

export default compose<PropsToComponent, {}>(
  connectToRouter((router) => ({
    slug: router.params.productSlug,
    programSlug: router.params.programSlug,
    specializationSlug: router.location.query?.specialization,
  }))
)(EnterpriseEnterpriseBffCourseDataProvider);
